import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
	selector: 'cost-center-presentation',
	templateUrl: "./cost-center.presentation.html",
	styles: [require("./cost-center.presentation.scss")]
})
export class CostCenterPresentation {
	private _costCenter: string;

	@Input() set costCenter(costCenter: string) {
		if (costCenter) {
			this._costCenter = costCenter
		}
	}

	@Output() private saveCostCenter = new EventEmitter<string>();
}



// WEBPACK FOOTER //
// ./src/app/components/event-components/cost-center/cost-center.presentation.ts